import { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// import "./slider.css";
import { getAnnualActivity } from "services/About";
import { imagePath } from "helper";
import { NextArrow, PrevArrow } from "components/Slider";
import DOMPurify from "dompurify";

const AboutAnnualActivity = () => {
  const [activityList, setActivityList] = useState(null);

  var settings = {
    dots: true,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: false,
    autoplaySpeed: 3500,
    adaptiveHeight: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  async function fetchActivity() {
    const result = await getAnnualActivity();

    setActivityList(result);
  }

  useEffect(() => {
    fetchActivity();
  }, []);

  return (
    <div className="pb-[80px] pt-0 md:py-[150px]">
      <div className="w-full max-w-[784px] mx-auto">
        <h1 className="font-taviraj text-32 md:text-[48px] leading-[80%] text-neutral-100 text-left md:text-center px-16">
          Annual Activity
        </h1>
        <div className="mt-[40px] md:mt-[80px]">
          <Slider {...settings} className="annual-activity-slider">
            {activityList?.map((item, index) => (
              <div className="block pb-16 md:pb-24 px-[18px]" key={index}>
                <div className="w-full aspect-[16/8] relative" key={item.id}>
                  <img
                    src={imagePath(item.id, item.banner, item.collectionName)}
                    alt={item.name}
                    className="w-full h-full object-center object-cover relative z-0 aspect-[16/8]"
                    loading="lazy"
                  />
                </div>
                <div className="font-taviraj text-16 md:text-20 leading-[20px] md:leading-[34px] text-center mt-16 md:mt-[40px] max-w-[708px] mx-auto">
                  <span className="font-medium text-primary-900 block mb-8 md:mb-0">
                    {item.year}
                  </span>
                  <p
                    className="text-neutral-100 block"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item.description),
                    }}
                  ></p>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default AboutAnnualActivity;
